import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MOCK_FINANCE } from '@src/mocks/finance';
import { Tabs } from '@components/ui/Tabs/Tabs';
import { SummaryRail } from './panels/SummaryRail';
import { OverviewTab } from './panels/OverviewTab';
import { CostsTab } from './panels/CostsTab';
import { BudgetTab } from './panels/BudgetTab';
import { InvoicesTab } from './panels/InvoicesTab';
import { QuotesTab } from './panels/QuotesTab';
import { OrdersTab } from './panels/OrdersTab';
import { PaymentsTab } from './panels/PaymentsTab';
import styles from './FinancePage.module.css';

type TabId = 'overview' | 'costs' | 'budget' | 'invoices' | 'quotes' | 'orders' | 'payments';

const TAB_ORDER: { id: TabId; labelKey: string; fallback: string }[] = [
  { id: 'overview', labelKey: 'finance.tabs.overview', fallback: 'Overview' },
  { id: 'costs',    labelKey: 'finance.tabs.costs',    fallback: 'Costs'    },
  { id: 'budget',   labelKey: 'finance.tabs.budget',   fallback: 'Budget'   },
  { id: 'invoices', labelKey: 'finance.tabs.invoices', fallback: 'Invoices' },
  { id: 'quotes',   labelKey: 'finance.tabs.quotes',   fallback: 'Quotes'   },
  { id: 'orders',   labelKey: 'finance.tabs.orders',   fallback: 'Orders'   },
  { id: 'payments', labelKey: 'finance.tabs.payments', fallback: 'Payments' },
];

export function FinancePage() {
  const { t } = useTranslation();
  const data = MOCK_FINANCE;
  const [active, setActive] = useState<TabId>('overview');

  return (
    <div className={styles.page}>
      <Tabs.Root value={active} onValueChange={(v) => setActive(v as TabId)}>
        <Tabs.List className={styles.tabList}>
          {TAB_ORDER.map((tab) => (
            <Tabs.Tab key={tab.id} value={tab.id} className={styles.tab}>
              {t(tab.labelKey, { defaultValue: tab.fallback })}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        <div className={styles.layout}>
          <SummaryRail summary={data.summary} filters={data.filters} />

          <div className={styles.content}>
            <Tabs.Panel value="overview" className={styles.panel}>
              <OverviewTab overview={data.overview} />
            </Tabs.Panel>
            <Tabs.Panel value="costs" className={styles.panel}>
              <CostsTab costs={data.costs} />
            </Tabs.Panel>
            <Tabs.Panel value="budget" className={styles.panel}>
              <BudgetTab budget={data.budget} />
            </Tabs.Panel>
            <Tabs.Panel value="invoices" className={styles.panel}>
              <InvoicesTab invoices={data.invoices} />
            </Tabs.Panel>
            <Tabs.Panel value="quotes" className={styles.panel}>
              <QuotesTab quotes={data.quotes} />
            </Tabs.Panel>
            <Tabs.Panel value="orders" className={styles.panel}>
              <OrdersTab orders={data.orders} />
            </Tabs.Panel>
            <Tabs.Panel value="payments" className={styles.panel}>
              <PaymentsTab payments={data.payments} />
            </Tabs.Panel>
          </div>
        </div>
      </Tabs.Root>
    </div>
  );
}
